import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokolhapurcabs() {



const cardData = {
  keyword: "Pune to Kolhapur Cab",
  heading: "Lotus Cab: Pune to Kolhapur Cab",

  headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Kolhapur Cab Service for family travel, business trips, corporate travel, pilgrimage tours, sightseeing, medical visits, and one-way or round-trip journeys. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe highway travel via NH48, Lotus Cabs ensures a comfortable, convenient, and hassle-free journey to Kolhapur and its famous religious, historical, and cultural attractions.",

  top: "Top Places to Visit in Kolhapur with Lotus Cab",

 topPlaces: [
    {
        title: "Mahalaxmi Temple",
        description:
            "Shree Mahalaxmi Temple, also known as Ambabai Temple, is one of Maharashtra's most sacred Shakti Peethas and the most visited attraction in Kolhapur. Devotees from across India visit the temple to seek the blessings of Goddess Mahalaxmi, admire its magnificent Hemadpanti architecture, and participate in the daily rituals and festive celebrations that make this temple a spiritually enriching destination."
    },
    {
        title: "Panhala Fort",
        description:
            "Panhala Fort is one of the largest and most historically significant forts in Maharashtra, closely associated with Chhatrapati Shivaji Maharaj. Surrounded by the Sahyadri Hills, the fort offers magnificent viewpoints, ancient gateways, secret passages, and historical monuments, making it a must-visit destination for history enthusiasts and families."
    },
    {
        title: "Rankala Lake",
        description:
            "Rankala Lake is a beautiful freshwater lake in the heart of Kolhapur, famous for its peaceful atmosphere, boating facilities, landscaped promenade, and spectacular sunset views. Families and tourists enjoy leisurely walks, local street food, and relaxing evenings while taking in the scenic beauty of this iconic city landmark."
    },
    {
        title: "Jyotiba Temple",
        description:
            "Located on Jyotiba Hill, this revered temple is dedicated to Lord Jyotiba and attracts thousands of devotees throughout the year. The temple is especially famous during the annual Chaitra Yatra when the entire hill is covered in pink gulal, creating a unique spiritual and cultural experience for visitors."
    },
    {
        title: "New Palace Museum",
        description:
            "The New Palace Museum showcases the royal heritage of the Kolhapur princely state through its impressive architecture, historic artifacts, royal costumes, weapons, paintings, and vintage collections. Visitors gain valuable insight into the region's rich Maratha history while exploring one of Kolhapur's finest heritage landmarks."
    },
    {
        title: "Radhanagari Wildlife Sanctuary",
        description:
            "Radhanagari Wildlife Sanctuary is a renowned nature reserve known for its dense forests, rich biodiversity, Indian bison (Gaur), diverse bird species, and scenic landscapes. Nature lovers and wildlife enthusiasts frequently visit this sanctuary to enjoy peaceful forest drives, photography, and eco-tourism experiences."
    },
    {
        title: "Dajipur Wildlife Sanctuary",
        description:
            "Dajipur Wildlife Sanctuary, also known as the Bison Sanctuary, is located amidst the lush Western Ghats and offers an excellent opportunity to witness wildlife in its natural habitat. Visitors enjoy forest safaris, scenic mountain views, and encounters with a variety of animals and birds, making it a perfect destination for adventure and nature lovers."
    },
    {
        title: "Kaneri Math",
        description:
            "Kaneri Math, officially known as Siddhagiri Gramjivan Museum, is a unique spiritual and cultural destination that beautifully showcases traditional Indian village life through life-sized sculptures and exhibits. The temple complex, museum, and peaceful surroundings make it a popular attraction for families, students, and pilgrims."
    },
    {
        title: "Narsobawadi",
        description:
            "Narsobawadi is a highly revered pilgrimage destination dedicated to Shri Narasimha Saraswati, an incarnation of Lord Dattatreya. Situated on the banks of the Krishna River, the temple attracts devotees seeking spiritual blessings, peace, and participation in traditional religious ceremonies throughout the year."
    },
    {
        title: "Gaganbawda",
        description:
            "Gaganbawda is a picturesque hill station near Kolhapur, known for its mist-covered mountains, lush green valleys, waterfalls, and breathtaking viewpoints. The pleasant climate and scenic drives through the Western Ghats make it an ideal destination for nature lovers, photographers, and travelers looking for a refreshing escape from city life."
    }
],

  services: [
    {
      name: "Pune to Kolhapur Cab",
      description:
        "Reliable Pune to Kolhapur cab service for safe and comfortable highway travel. AC sedan and SUV vehicles available. Professional drivers assigned for long-distance routes. Transparent pricing policy maintained. Ideal for pilgrimage and family trips."
    },
    {
      name: "Pune to Kolhapur Taxi Service",
      description:
        "Affordable taxi service from Pune to Kolhapur with flexible pickup options. One-way and round-trip packages available. Clean and well-maintained vehicles provided. Safe and punctual travel guaranteed."
    },
    {
      name: "Pune to Kolhapur One Way Cab",
      description:
        "Budget-friendly one-way cab from Pune to Kolhapur where you pay only for single distance. No return charges applied. Ideal for business and personal travel. Comfortable AC vehicles ensured."
    },
    {
      name: "Pune to Kolhapur Round Trip Taxi",
      description:
        "Convenient round-trip taxi option for Pune to Kolhapur travel. Flexible return timing allowed. Perfect for temple visits and sightseeing. Transparent billing and safe travel assured."
    },
    {
      name: "Luxury Cab Pune to Kolhapur",
      description:
        "Premium luxury cab options for executive and VIP travel. Spacious interiors and smooth highway drive. Professional chauffeurs assigned. Ideal for corporate and special trips."
    },
    {
      name: "SUV Taxi Pune to Kolhapur",
      description:
        "Spacious SUV taxi suitable for families and groups. Extra luggage space available. Comfortable long-distance seating provided. Reliable and safe travel experience."
    },
    {
      name: "Sedan Taxi Pune to Kolhapur",
      description:
        "Affordable sedan cab option for individuals and small families. Air-conditioned and well-maintained vehicles. Transparent fare structure maintained."
    },
    {
      name: "Online Cab Booking Pune to Kolhapur",
      description:
        "Instant online booking available for Pune to Kolhapur cab service. Easy confirmation and quick support. 24/7 customer assistance provided."
    }
  ],

  tableData: [
    ["Pune to Kolhapur Cab", "Pune to Kolhapur Taxi Service"],
    ["Pune to Kolhapur One Way Cab", "Pune to Kolhapur Round Trip Taxi"],
    ["Pune to Kolhapur Outstation Cab", "Affordable Pune to Kolhapur Cab"],
    ["Luxury Cab Pune to Kolhapur", "SUV Taxi Pune to Kolhapur"],
    ["Sedan Taxi Pune to Kolhapur", "Online Cab Booking Pune to Kolhapur"],
    ["Family Trip Cab Pune to Kolhapur", "Corporate Taxi Pune to Kolhapur"],
    ["Pune to Mahalaxmi Temple Kolhapur Cab", "AC Taxi Pune to Kolhapur"],
    ["Best Cab Service Pune to Kolhapur", ""]
  ],

  whychoose: [
    { WhyChooseheading: "Safe Highway Travel", WhyChoosedescription: "Experienced drivers ensure smooth Pune to Kolhapur highway travel." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-km fare structure with no hidden charges." },
    { WhyChooseheading: "Comfortable AC Vehicles", WhyChoosedescription: "Clean and well-maintained sedan and SUV fleet available." },
    { WhyChooseheading: "Flexible Trip Options", WhyChoosedescription: "One-way and round-trip packages available." },
    { WhyChooseheading: "Pilgrimage Travel Support", WhyChoosedescription: "Timely temple visit travel assistance provided." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock booking and customer assistance." },
    { WhyChooseheading: "Corporate Travel Ready", WhyChoosedescription: "Professional service for business travelers." },
    { WhyChooseheading: "Family-Friendly Service", WhyChoosedescription: "Spacious vehicles suitable for family trips." }
  ]
};

const faqData = [
  { question: "Do you provide one-way Pune to Kolhapur cab?", answer: "Yes, affordable one-way cab service available." },
  { question: "Is round-trip option available?", answer: "Yes, flexible round-trip packages provided." },
  { question: "Are vehicles AC?", answer: "Yes, all vehicles are air-conditioned." },
  { question: "Is booking available 24/7?", answer: "Yes, round-the-clock booking available." },
  { question: "Are drivers experienced?", answer: "Yes, trained highway drivers assigned." },
  { question: "Do you provide SUV option?", answer: "Yes, SUV taxis available for families." },
  { question: "Are toll charges included?", answer: "Toll charges are informed transparently." },
  { question: "Is online booking available?", answer: "Yes, instant booking available." },
  { question: "Do you provide corporate cab?", answer: "Yes, corporate travel support available." },
  { question: "Is temple visit cab available?", answer: "Yes, Mahalaxmi Temple travel supported." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Patil",
    feedback:
      "Booked Pune to Kolhapur cab for Mahalaxmi Temple visit. Very smooth journey and professional driver. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback:
      "SUV taxi was comfortable for our family trip. Transparent pricing and punctual service. Excellent experience.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Used Lotus Cab for business travel to Kolhapur. Professional service and safe highway driving.",
    rating: 5
  }
];




































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Kolhapur Cab Service",
"image": "https://lotuscab.com/assets/images/pune-to-kolhapur-cab-service.jpg",
"description": "Book Pune to Kolhapur Cab Service with Lotus Cab for safe, comfortable, and affordable intercity travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6791"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-kolhapur-cab-service"
}
};









  return (
    <div>
      


<Helmet>
  <title>Pune to Kolhapur Cab Service | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Kolhapur Cab Service with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, experienced drivers, instant booking, and 24x7 customer support."
/>

<meta
 name="keywords"
 content="Pune to Kolhapur Cab Service, Pune to Kolhapur Cab, Pune to Kolhapur Taxi, Pune to Kolhapur Taxi Service, Kolhapur Cab from Pune, One Way Cab Pune to Kolhapur, Round Trip Cab Pune to Kolhapur, Outstation Cab Pune to Kolhapur, Pune to Mahalaxmi Temple Cab, Pune to Kolhapur Mahalaxmi Darshan Cab, Affordable Pune to Kolhapur Cab, Cheap Pune to Kolhapur Taxi, Online Pune to Kolhapur Cab Booking, Sedan Cab Pune to Kolhapur, SUV Cab Pune to Kolhapur, Best Pune to Kolhapur Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokolhapurcabs;